import config from "config/config";

export const isAnnuityPolicyInactive = (policy) => {
  if (!policy || !policy.statusCode || !policy.status) {
    return false;
  }
  const ANNUITY_POLICY_INACTIVE_STATUS_CODES =
    config?.ANNUITY_POLICY_INACTIVE_STATUS_CODES?.split(",") ?? [];
  return ANNUITY_POLICY_INACTIVE_STATUS_CODES.includes(policy.statusCode);
};
